<template>
  <b-modal id="confirm-delete-special-discount-modal" dialog-class="base-modal" :title="title" centered
    footer-class="mt-3" header-class="align-items-start mt-3" title-class="position-relative px-md-5 mx-md-4">
    <p class="text-center px-md-5">{{ message }}</p>
    <template #modal-footer>
      <b-button pill variant="outline-secondary" class="mx-2" @click="closeModal">Keep</b-button>
      <b-button 
        :style="{
          'background-color': webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
          border: webDesign && webDesign.design ? 'none !important' : null,
          color: webDesign && webDesign.design ? `${webDesign.design.button_text_color} !important` : null
        }"
        pill class="mx-2" @click="!isLoading ? deleteSpecialDiscount() : null"
      >
        Delete
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "ConfirmDeleteSpecialDiscountIdModal",
  data() {
    return {
      title: "Delete SC/PWD ID?",
      message: "Are you sure you want to delete this special discount?"
    }
  },
  computed: {
    ...mapState("estore", ["cartSpecialDiscount", "webDesign"]),
    specialDiscountToDelete() {
      return this.$store.state.estore.specialDiscountToDelete || null;
    },
    requestHeader() {
      return {
        Authorization: this.$store.state.auth.token,
        "X-Merchant-Token": this.$store.state.merchant.customerPortalToken
      }
    },
    apiErrors() {
      return this.$store.state.estore.errors || {};
    },
    isLoading() {
      return this.$store.state.estore.loading;
    }
  },
  methods: {
    closeModal() {
      if (this.$route.name === "Checkout")
        this.$bvModal.show("discount-modal");

      this.$bvModal.hide("confirm-delete-special-discount-modal");
    },
    async deleteSpecialDiscount() {
      if (this.specialDiscountToDelete) {
        const request = {
          header: this.requestHeader,
          payload: {
            uuid: this.specialDiscountToDelete
          }
        };
        await this.$store.dispatch("estore/deleteSpecialDiscount", request).then(() => {
          if (_.isEmpty(this.apiErrors)) {
            if (_.get(this.cartSpecialDiscount, "uuid") === this.specialDiscountToDelete)
              this.$store.commit("estore/setCartSpecialDiscount", null); 

            this.$store.state.estore.specialDiscountToDelete = null;
            this.closeModal();
            if (this.$route.name === "Profile")
              this.$emit("fetchSpecialDiscounts");

            this.$root.$emit("refreshCartItems");
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#confirm-delete-special-discount-modal {
  .modal-footer {
    justify-content: space-evenly;

    &>.btn {
      width: calc(50% - 0.5rem * 2);
      height: 50px;
      font-size: 16px;
    }
  }
}
</style>

<style lang="scss">
#confirm-delete-special-discount-modal {
  .modal-title {
    font-size: 24px;
    top: 20px;
  }
}
</style>
